module.exports = __webpack_public_path__ + "static/img/SketchPnge18ee852644e1fa15d7ca4c345f4f17ef08053e57cd03a6e9d47fe04eebef636.22acdd6a.png";